import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$e } from './input.js';
import { d as defineCustomElement$m } from './box.js';
import { d as defineCustomElement$l } from './button.js';
import { d as defineCustomElement$k } from './check-input.js';
import { d as defineCustomElement$j } from './check-list-input.js';
import { d as defineCustomElement$i } from './close-button.js';
import { d as defineCustomElement$h } from './divider.js';
import { d as defineCustomElement$g } from './form-field.js';
import { d as defineCustomElement$f } from './icon.js';
import { d as defineCustomElement$d } from './layout.js';
import { d as defineCustomElement$c } from './list.js';
import { d as defineCustomElement$b } from './list-item.js';
import { d as defineCustomElement$a } from './list-item-divider.js';
import { d as defineCustomElement$9 } from './list-item-header.js';
import { d as defineCustomElement$8 } from './list-item-meta.js';
import { d as defineCustomElement$7 } from './loader.js';
import { d as defineCustomElement$6 } from './menu-pane.js';
import { d as defineCustomElement$5 } from './more-menu.js';
import { d as defineCustomElement$4 } from './status.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const tableHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:row;font-family:Open Sans;font-size:.875rem;font-weight:400;justify-content:space-between;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.filters{display:flex;flex:1;flex-direction:row;gap:.5rem}.filters>*{max-width:var(--jw-container-xs)}::slotted(wui-multi-select-input){width:auto}.actions{display:flex;flex:none;flex-direction:row;gap:.5rem}";
const WuiTableHeaderStyle0 = tableHeaderCss;

const DENSITY_LABELS = {
    sm: 'small',
    md: 'medium',
    lg: 'large',
};
const DENSITY_ICONS = {
    sm: 'baseline-density-small',
    md: 'baseline-density-medium',
    lg: 'baseline-density-large',
};
const WuiTableHeader$1 = /*@__PURE__*/ proxyCustomElement(class WuiTableHeader extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.changeSearchQuery = createEvent(this, "changeSearchQuery", 7);
        this.changeVisibleColumns = createEvent(this, "changeVisibleColumns", 7);
        this.changeDensity = createEvent(this, "changeDensity", 7);
        this.searchInput = undefined;
        this.searchQuery = undefined;
        this.columns = undefined;
        this.visibleColumns = undefined;
        this.densities = undefined;
        this.density = undefined;
    }
    render() {
        const showDensityButtons = Boolean(this.density && this.densities?.length);
        const showColumnsInput = Boolean(this.columns?.length && typeof this.visibleColumns !== 'undefined');
        return (h(Host, { key: '8934f31dc450bff1f12e7fc361d0998f3b3cce19' }, h("div", { key: '54f14d869ef73f2d3c2d7e221105de9bde83083f', class: "filters" }, h("wui-input", { key: '7a26224daa894b8b387afdb4fddbcacc83e65ce5', type: "search", placeholder: this.searchInput?.placeholder ?? 'Search', value: this.searchQuery, onInput: (e) => {
                this.changeSearchQuery.emit(e.currentTarget?.value ?? '');
            } }), h("slot", { key: '5e41acab5a94f106cd4d2c3e434442998e44c4d5' })), h("div", { key: 'f31b7896af691a0c31c4574d18cc8965736afb1e', class: "actions" }, showDensityButtons && (h("wui-layout", { key: '0bf7b913b357f5aea488360ed21b8fd715fc3c50', type: "button-group", variant: "button-group-tight" }, this.densities?.map((density) => {
            return (h("wui-button", { key: density, tooltip: `Density: ${DENSITY_LABELS[density]}`, icon: DENSITY_ICONS[density], type: "ghost", toggled: this.density === density, onClick: () => {
                    this.changeDensity.emit(density);
                } }));
        }))), showDensityButtons && showColumnsInput && h("wui-divider", { key: 'd1c77cdba8796443ac99b9e9989deeee6b89181d', type: "vertical" }), showColumnsInput && (h("wui-more-menu", { key: 'f877739b14acd704d774b1f7b5918328c503ba31', icon: "settings", menuPane: { placement: 'bottom-end' } }, h("wui-check-list-input", { key: '9d11dc12721b643f54f55b0b21306e1fa9498214', options: this.columns?.map((col) => {
                const value = 'name' in col ? col.name : col.value;
                const label = col.label;
                return {
                    value,
                    label,
                };
            }), value: this.visibleColumns, onInput: (e) => {
                this.changeVisibleColumns.emit(e.currentTarget?.value ?? []);
            } }))))));
    }
    static get style() { return WuiTableHeaderStyle0; }
}, [1, "wui-table-header", {
        "searchInput": [16],
        "searchQuery": [1, "search-query"],
        "columns": [16],
        "visibleColumns": [16],
        "densities": [16],
        "density": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-table-header", "wui-box", "wui-button", "wui-check-input", "wui-check-list-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-input", "wui-layout", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-menu-pane", "wui-more-menu", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-table-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTableHeader$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$m();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTableHeader = WuiTableHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTableHeader, defineCustomElement };

//# sourceMappingURL=wui-table-header.js.map